import React, { Component } from "react";
import { connect } from "react-redux";
//import { addShipping } from './actions/cartActions'
//import {sendData} from '../../actions/cart_Action'

import { ButtonContainer } from "../Button/Button";

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class Recipe extends Component {
  state = {
    loading: false
  };

  fetchData = () => {
    this.setState({ loading: true });

    //Faking API call here
    this.handleClick()
    setTimeout(() => {
      this.setState({ loading: false });
    }, 3000);
  
  };

  // componentWillUnmount() {
  //      if(this.refs.shipping.checked)
  //           this.props.substractShipping()
  // }

  // handleChecked = (e)=>{
  //     if(e.target.checked){
  //         this.props.addShipping();
  //     }
  //     else{
  //         this.props.substractShipping();
  //     }
  // }

  
  handleClick = () => {
  
   this.props.eosio3.upsert(this.props.addedItems, this.props.total,this.props.tokenName2,this.props.contractName2) 

  };

  render() {
    const { loading } = this.state;
    return (
      <div className="container">
          
        <div className="collection">
          {/* <li className="collection-item">
                            <label>
                                <input type="checkbox" ref="shipping" onChange= {this.handleChecked} ></input>
                                
                                <span>Shipping(+6$)</span>
                            </label>
                        </li> */}
          <b>Total: {this.props.total} {this.props.tokenName2}</b>
        </div>

        <div className="checkout">
          <ButtonContainer
            variant="primary"
            onClick={() => {
              this.fetchData()
              //this.handleClick();
            }}

         disabled={loading}>
          {loading && (
            <i
              className="fa fa-refresh fa-spin"
              style={{ marginRight: "5px" }}
            />
          )}
          {loading && <span>Loading... </span>}
          {!loading && <span>Checkout</span>}
 
          
          
          </ButtonContainer>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addedItems: state.addedItems,
    total: state.total
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addShipping: () => {
      dispatch({ type: "ADD_SHIPPING" });
    },
    substractShipping: () => {
      dispatch({ type: "SUB_SHIPPING" });
    },
    sendData: () => {
      dispatch({ type: "SEND_DATA" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Recipe);
